import flagus from "../../assets/images/flags/us.svg";
import flagspain from "../../assets/images/flags/spain.svg";
import flaggermany from "../../assets/images/flags/germany.svg";
import flagitaly from "../../assets/images/flags/italy.svg";
import flagrussia from "../../assets/images/flags/russia.svg";
import flagchina from "../../assets/images/flags/china.svg";
import flagfrench from "../../assets/images/flags/french.svg";
import flagarabic from "../../assets/images/flags/ae.svg";


const languages = [
    {
        lang: "en",
        label: "English",
        flag: flagus,
    },
    {
        lang: "gr",
        label: "Deutsche",
        flag: flaggermany,
    },
    {
        lang: "it",
        label: "Italiana",
        flag: flagitaly,
    },
    {
        lang: "rs",
        label: "русский",
        flag: flagrussia,
    },
    {
        lang: "sp",
        label: "Española",
        flag: flagspain,
    },
    {
        lang: "cn",
        label: "中国人",
        flag: flagchina,
    },
    {
        lang: "fr",
        label: "français",
        flag: flagfrench,
    },
    {
        lang: "ar",
        label: "Arabic",
        flag: flagarabic,
    },
];

export default languages;
